<template>
  <nav class="navbar navbar-expand-md app-header">
    <b-navbar-brand v-bind:[linkType]="homeLink">
      <svg-icon name="logo" />
    </b-navbar-brand>
  </nav>
</template>

<script>
export default {
  name: "HeaderDefault",
  computed: {
    linkType() {
      return process.env.VUE_APP_HOME_LINK_EXTERNAL === 'true' ? 'href' : 'to';
    },
    homeLink() {
      return process.env.VUE_APP_HOME_LINK;
    }
  }
};
</script>